<!--
  El <audio> vive SIEMPRE en el DOM, también con el modal cerrado: si se creara
  al contestar, la pista remota podría llegar antes que el elemento y el agente
  se quedaría sin oír al cliente.
-->
<audio #audioRemoto autoplay></audio>

@if (visible()) {
  @if (minimizada()) {
    <!--
      Apartada: una píldora en la esquina en vez del modal a pantalla completa.
      Deja seguir trabajando en el CRM sin perder de vista que hay una llamada.
    -->
    <button type="button" class="llamada-pildora" (click)="restaurar()" title="Volver a la llamada">
      <span class="llamada-pildora__punto"></span>
      <lucide-icon name="phone" [size]="16"></lucide-icon>
      <span class="llamada-pildora__texto">
        {{ llamada()?.nombre || llamada()?.telefono }}
        @if (estado() === 'activa') { · {{ duracion() }} }
      </span>
    </button>
  } @else {
    <div class="llamada-capa">
      <div class="llamada-tarjeta">

        <div class="llamada-avatar" [class.llamada-avatar--quieto]="estado() === 'activa'">
          <lucide-icon name="phone" [size]="28"></lucide-icon>
        </div>

        <p class="llamada-nombre">{{ llamada()?.nombre || 'Número desconocido' }}</p>
        <p class="llamada-telefono">+{{ llamada()?.telefono }}</p>

        <p class="llamada-estado">
          @switch (estado()) {
            @case ('sonando')    { Llamada de WhatsApp entrante… }
            @case ('conectando') { Conectando… }
            @case ('llamando')   { Llamando… }
            @case ('activa')     { {{ duracion() }} }
          }
        </p>

        <!-- Calidad de la red: contesta en caliente si se oye mal por quién. -->
        @if (estado() === 'activa' && senal(); as s) {
          <p class="llamada-senal" [class]="'llamada-senal ' + s.clase" [title]="s.detalle">
            <span class="llamada-senal__punto"></span>
            Señal {{ s.texto }}
          </p>
        }

        @if (error()) {
          <p class="llamada-error">{{ error() }}</p>
        }

        <!--
          Al contestar sin permiso, el navegador pregunta y esos segundos
          cuentan contra la ventana de Meta. Avisarlo aquí evita que el agente
          se quede leyendo el diálogo sin entender por qué salió.
        -->
        @if (estado() === 'sonando' && microfono() === 'prompt') {
          <p class="llamada-aviso-mic">
            <lucide-icon name="mic" [size]="13"></lucide-icon>
            Al contestar, el navegador te pedirá permiso para el micrófono
          </p>
        }
        @if (estado() === 'sonando' && microfono() === 'denied') {
          <p class="llamada-error">
            El micrófono está bloqueado: habilítalo en el candado de la barra de direcciones o no podrás hablar.
          </p>
        }

        <div class="llamada-botones">
          @if (estado() === 'sonando') {
            <button type="button" class="llamada-btn llamada-btn--colgar" (click)="rechazar()" title="Rechazar la llamada">
              <lucide-icon name="phone-missed" [size]="22"></lucide-icon>
            </button>
            <button type="button" class="llamada-btn llamada-btn--contestar" (click)="contestar()" title="Contestar">
              <lucide-icon name="phone" [size]="22"></lucide-icon>
            </button>
          }

          @if (estado() === 'conectando') {
            <lucide-icon name="loader-2" class="llamada-cargando" [size]="26"></lucide-icon>
          }

          <!-- Saliente esperando: solo se puede desistir. -->
          @if (estado() === 'llamando') {
            <button type="button" class="llamada-btn llamada-btn--colgar" (click)="colgar()" title="Cancelar la llamada">
              <lucide-icon name="phone-missed" [size]="22"></lucide-icon>
            </button>
          }

          @if (estado() === 'activa') {
            <button
              type="button"
              class="llamada-btn"
              [class.llamada-btn--mic]="!silenciado()"
              [class.llamada-btn--mic-off]="silenciado()"
              (click)="alternarMicrofono()"
              [title]="silenciado() ? 'Activar micrófono' : 'Silenciar mi micrófono'">
              <lucide-icon [name]="silenciado() ? 'mic-off' : 'mic'" [size]="22"></lucide-icon>
            </button>
            <button type="button" class="llamada-btn llamada-btn--colgar" (click)="colgar()" title="Colgar">
              <lucide-icon name="phone-missed" [size]="22"></lucide-icon>
            </button>
          }
        </div>

        <!--
          Acciones secundarias, deliberadamente discretas: son atajos, no la
          decisión principal. "Silenciar" calla el timbre sin rechazar la
          llamada, que es distinto de dar plantón al cliente.
        -->
        <div class="llamada-secundarias">
          @if (estado() === 'sonando') {
            <button type="button" (click)="silenciarTimbre()">Silenciar timbre</button>
            <span class="llamada-sep">·</span>
          }
          <button type="button" (click)="minimizar()">Apartar a un lado</button>
        </div>

        @if (silenciado()) {
          <p class="llamada-aviso-mute">
            <lucide-icon name="mic-off" [size]="13"></lucide-icon>
            Tu micrófono está silenciado
          </p>
        }

      </div>
    </div>
  }
}
